import { Environment } from 'store/constants';
import { PendoEnvironmentTypes } from './types';

export const PENDO_ENVIRONMENT_CONFIG: Record<Environment, PendoEnvironmentTypes> = {
  production: 'US-PROD',
  uat: 'US-UAT',
  demo: 'US-DEMO',
  training: 'US-TRAINING',
  auto: 'US-AUTO',
  qa: 'US-QA',
  staging: 'US-STAGING',
  dev: 'DEV',
  devint: 'DEV-INT',
  perf2: 'US-PERF2',
  local: 'UNKNOWN',
};
